export const ALIGN_NODES_MODAL = 'align-nodes';
export const CLONE_HAS_UNSAVED_CHANGES_MODAL = 'clone-has-unsaved-changes';
export const CLONE_JOURNEY_MODAL = 'clone-journey-modal';
export const CLONE_NODE_MODAL = 'clone-nodes';
export const CREATE_LIST_MODAL = 'create-list';
export const CREATE_TILESET_MODAL = 'create-tileset-modal';
export const DELETE_DRAFT_MODAL = 'delete-draft';
export const DELETE_NODE_MODAL = 'delete-nodes';
export const DESELECT_CHANNELS_MODAL = 'deselect-channels-modal';
export const DRAFT_HAS_UNSAVED_CHANGES_MODAL = 'draft-has-unsaved-changes';
export const EXIT_RULES_MODAL = 'exit-rules';
export const FIX_STUCK_USERS_MODAL = 'fix-stuck-users';
export const NAVIGATION_TIPS_MODAL = 'navigation-tips';
export const SEND_TEST_TRIGGER_MODAL = 'send-test-trigger';
export const WORKFLOW_DETAILS_MODAL = 'workflow-details';
export const READ_ONLY_EXIT_RULES_MODAL = 'read-only-exit-rules';
export const PUBLISH_CAMPAIGN_MODAL = 'publish-campaign';
export const PUBLISH_JOURNEY_MODAL = 'publish-journey';
export const RESET_TO_PUBLISHED_MODAL = 'reset-to-published';
export const NODE_HAS_UNSAVED_CHANGES_MODAL = 'node-has-unsaved-changes';
export const PREVIEW_YES_NO_SPLIT_MODAL = 'preview-yes-no-split';
export const RESTORE_AS_DRAFT_CONFIRMATION_MODAL = 'restore-as-draft-confirmation-modal';
export const SELECT_TILESET_MODAL = 'select-tileset-modal';
export const SETTINGS_HAS_UNSAVED_CHANGES_MODAL = 'settings-has-unsaved-changes';
export const SETTINGS_SAVE_CHANGES_MODAL = 'settings-save-changes';
export const SWITCH_PROJECTS_MODAL = 'switch-projects-modal';
export const TOGGLE_JOURNEY_MODAL = 'activate-workflow';
export const CLEAR_JOURNEY_CONVERSIONS_MODAL = 'clear-journey-conversions';
export const JOURNEY_TESTING_MODAL = 'journey-testing-modal';
export const HOLD_UNTIL_REPLY_SWITCH_MEDIUM_MODAL = 'hold-until-reply-switch-medium-modal';
export const HOLD_UNTIL_REPLY_DELETE_REPLY_MODAL = 'hold-until-reply-delete-reply-modal';
export const HOLD_UNTIL_REPLY_SWITCH_CAMPAIGN_MODAL = 'hold-until-reply-switch-campaign-modal';
